import { RouteFactory } from "@app/routePaths";
import { NEWSLETTER_TYPE } from "@components/Newsletter/types/Newsletter";

import { Listing, NewsletterConfig } from "./types";

export const LISTING_NEWSLETTER_CONFIG: NewsletterConfig<Listing>[] = [
  {
    pageURLs: [
      "/property",
      "/companies-markets/reits-property",
      RouteFactory.newslettersPropertyInsights,
    ],
    name: { desktop: "Property Insights" },
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner: "Tuesdays: Exclusive real estate and property news analysis.",
    types: [NEWSLETTER_TYPE.PROPERTY],
  },
  {
    pageURLs: [RouteFactory.esg, RouteFactory.newslettersEsgInsights],
    name: { desktop: "ESG Insights" },
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner: "Fridays: Latest environmental, social & governance issues.",
    types: [NEWSLETTER_TYPE.ESG],
  },
  {
    pageURLs: [
      RouteFactory.aseanBusiness,
      RouteFactory.newslettersAseanBusiness,
    ],
    name: { desktop: "Asean Business" },
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner:
      "Fridays: Business insights on Southeast Asia's fast-growing economies.",
    types: [NEWSLETTER_TYPE.ASEAN],
  },
  {
    pageURLs: [RouteFactory.sgsme, "/startups-tech"],
    name: { desktop: "SGSME Newsletter" },
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner:
      "Fridays: Hottest updates on the local SME scene to wrap up your week.",
    types: [NEWSLETTER_TYPE.SGSME],
  },
  {
    pageURLs: [
      "/singapore",
      "/singapore/economy-policy",
      "/companies-markets",
      "/companies-markets/banking-finance",
      RouteFactory.newslettersDaily,
    ],
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner: "Start and end each day with the latest news stories and analyses.",
    types: [NEWSLETTER_TYPE.MORNING, NEWSLETTER_TYPE.EVENING],
  },
  {
    pageURLs: [RouteFactory.newslettersLifestyle],
    tagLine: {
      desktop: "Lifestyle Newsletter",
      mobile: "STRAIGHT TO YOUR INBOX",
    },
    liner:
      "Fridays: Our picks of the latest dining, travel and leisure options to treat yourself.",
    types: [NEWSLETTER_TYPE.LIFESTYLE],
  },
  {
    pageURLs: [RouteFactory.newsletters],
    tagLine: { mobile: "STRAIGHT TO YOUR INBOX" },
    liner:
      "Receive all free BT newsletters in your inbox! Get daily updates and weekly deep dives on topics that matter to the business community.",
    types: [
      NEWSLETTER_TYPE.MORNING,
      NEWSLETTER_TYPE.EVENING,
      NEWSLETTER_TYPE.ASEAN,
      NEWSLETTER_TYPE.LIFESTYLE,
      NEWSLETTER_TYPE.PROPERTY,
      NEWSLETTER_TYPE.ESG,
      NEWSLETTER_TYPE.SGSME,
      NEWSLETTER_TYPE.THRIVE,
    ],
  },
  {
    pageURLs: [RouteFactory.newslettersBigMoney],
    tagLine: {
      desktop: "Big Money",
      mobile: "STRAIGHT TO YOUR INBOX",
    },
    liner:
      "Mondays: A breakdown of the latest developments affecting financial markets.",
    types: [NEWSLETTER_TYPE.BIGMONEY],
  },
];

export const DAILY_NEWSLETTER_SECTION_CONFIG: NewsletterConfig<string[]> = [
  "newsletters_breakfast-brief",
  "newsletters_daily-debrief",
];
